<template>
  <v-container id="order-detail">
    <div class="mx-auto mt-4 mt-lg-0 mb-8 d-print-none d-lg-flex justify-space-between _w-lg-21cm">
      <v-btn
        text
        exact
        @click="$router.go(-1)">
        <v-icon left>
          mdi-chevron-left
        </v-icon>
        กลับ
      </v-btn>

      <div class="d-none d-lg-block">
        <v-btn
          color="primary"
          rounded
          outlined
          min-width="200"
          @click="setOrderDetailType('quotation')">
          ใบเสนอราคา
        </v-btn>

        <v-btn
          class="ml-4"
          color="primary"
          rounded
          outlined
          min-width="200"
          @click="setOrderDetailType('invoice')">
          ใบแจ้งหนี้
        </v-btn>
      </div>

      <v-btn
        class="d-none d-lg-block"
        color="primary"
        rounded
        min-width="200"
        @click="onPrint">
        <v-icon left>
          mdi-printer
        </v-icon>
        พิมพ์
      </v-btn>
    </div>

    <line-diy-quotation
      :order="order"
      :order-detail-type="orderDetailType"
      :basic-id="order.basicId">
    </line-diy-quotation>
  </v-container>
</template>

<script>
import { mapState } from 'vuex'
import store from '@/store'

export default {
  name: 'OrderDetail',
  components: {
    LineDiyQuotation: () => import('@/components/LineDiyQuotation.vue')
  },
  props: {
    id: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      orderDetailType: 'quotation'
    }
  },
  computed: {
    ...mapState('Order', ['order'])
  },
  async beforeRouteEnter (to, from, next) {
    try {
      store.dispatch('wait/start', 'app loading', { root: true })
      const order = await store.dispatch('Order/fetchOrderById', to.params.id)
      store.dispatch('wait/end', 'app loading', { root: true })
      if (order.status === 'deleted') {
        next({ name: 'NotFound' })
      } else {
        next()
      }
    } catch {
      next({ name: 'NotFound' })
    }
  },
  methods: {
    setOrderDetailType (value) {
      this.orderDetailType = value
    },
    onPrint () {
      window.print()
    }
  }
}
</script>

<style scoped>
@media (min-width: 1264px) {
  ._w-lg-21cm {
    width: 21cm;
  }
}
</style>
